(function () {
  'use strict';

  function initCarousel(carousel) {
    if (carousel.dataset.royalCarouselReady === 'true') return;
    carousel.dataset.royalCarouselReady = 'true';

    const track = carousel.querySelector('[data-royal-carousel-track]');
    const previous = carousel.querySelector('[data-royal-carousel-prev]');
    const next = carousel.querySelector('[data-royal-carousel-next]');
    if (!track || !previous || !next) return;

    function scrollAmount() {
      const card = track.querySelector('.cat-food-guide__royal-variant');
      if (!card) return track.clientWidth * 0.8;
      const styles = window.getComputedStyle(track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
      return (card.getBoundingClientRect().width + gap) * 2;
    }

    function updateControls() {
      const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maximum - 2;
    }

    previous.addEventListener('click', () => {
      track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });

    carousel.addEventListener('click', (event) => {
      const control = event.target.closest('[data-royal-quantity]');
      if (!control) return;

      const form = control.closest('form');
      const input = form && form.querySelector('input[name="quantity"]');
      if (!input) return;

      const minimum = Number.parseInt(input.min, 10) || 1;
      const maximum = Number.parseInt(input.max, 10) || 99;
      const current = Number.parseInt(input.value, 10) || minimum;
      const direction = control.dataset.royalQuantity;
      input.value = direction === 'increase'
        ? Math.min(maximum, current + 1)
        : Math.max(minimum, current - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    track.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls, { passive: true });
    updateControls();
  }

  function initAll() {
    document.querySelectorAll('[data-royal-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
